import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import UserAvatar from '../Users/UserAvatar';
import CardRow from '../Kanban/CardRow';
import CloseIcon from '@mui/icons-material/Close';
import FlagIcon from '@mui/icons-material/Flag'
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined'
import IconButton from '@mui/material/IconButton';
import MainStore from '../../../MainStore'
import AuthStore from '../../Auth/AuthStore'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SaleStore from './SaleStore';
//import Draggable from 'react-draggable';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import WorkStore from '../Kanban/WorkStore';
import Tooltip from '@mui/material/Tooltip';

export default class InvoiceBoardCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isTimeDialogOpen: false,
            isOver: false,
            time: '',
            comment: '',
            needLogin: false,
            newNotify: '',
            isCommentDialogOpen: false,
            flagDialogTitle: '',
            flagComment: '',
            delayTo: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleTimeClose = this.handleTimeClose.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleTimeSave = this.handleTimeSave.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
        this.flag = this.flag.bind(this);
        this.unFlag = this.unFlag.bind(this);
        this.handleCommentClose = this.handleCommentClose.bind(this);
        this.handleCommentSave = this.handleCommentSave.bind(this);
        this.isDatePast = this.isDatePast.bind(this);
        this.isEmptyProfit = this.isEmptyProfit.bind(this);
        this.handleWorkAdd = this.handleWorkAdd.bind(this);
    }

    handleWorkAdd() {
        var work = {
            invoiceId: this.props.sale.id, invoiceNumber: this.props.sale.number + ' ' + this.props.sale.caption,
            account: this.props.sale.account,
            accountId: this.props.sale.accountId,
            assignee: AuthStore.getUser.fullName,
            assigneeRoleId: AuthStore.getUser.roleId,
            assigneeId: AuthStore.getUserId};
        WorkStore.openWorkDialog(work);
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleClose() {
        this.setState({ isSaleDialogOpen: false });
    }

    handleTimeClose() {
        this.setState({ isTimeDialogOpen: false });
    }

    handleTimeSave() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Sale/AddTime', {
            method: 'POST',
            body: JSON.stringify({ Time: this.state.time, SaleId: this.props.sale.id }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onTimeChange) {
                        scope.props.onTimeChange(result.time, scope.props.sale.id)
                    }
                    MainStore.setMaskUnvisible();
                    scope.setState({ isTimeDialogOpen: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleDragOver(e) {
        console.log('handleDragOver ' + new Date());
     /*   if (e.preventDefault) {
            e.preventDefault(); // Necessary. Allows us to drop.
        }
        if (!this.state.isOver) {
            this.setState({ isOver: true });
        }

        e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.
        */
        return false;
    }

    handleCardClick(e) {
        if (e.ctrlKey && this.props.onCtrlCardClick) {
            this.props.onCtrlCardClick(this.props.sale.id);
        }
    }

    flag() {
        this.setState({ isCommentDialogOpen: true, newFlag: true, flagDialogTitle: 'Почему ты флажишь?', flagComment: '' });
    }

    handleCommentClose() {
        this.setState({ isCommentDialogOpen: false });
    }

    unFlag() {
        this.setState({ isCommentDialogOpen: true, newFlag: false, flagDialogTitle: 'Почему ты убираешь флаг?', flagComment: '' });
    }

    handleCommentSave() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Invoice/FlagAndComment', {
            method: 'POST',
            body: JSON.stringify({ WorkId: this.props.sale.id, Comment: this.state.flagComment, Flag: this.state.newFlag, DelayTo: this.state.delayTo }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onSaleUpdate) {
                        scope.props.onSaleUpdate(result)
                    }
                    MainStore.setMaskUnvisible();
                    scope.setState({ isCommentDialogOpen: false, delayTo: null });
                }).catch((err) => console.log(err));
            }
        });
    }

    isDatePast() {
        var nextDay = new Date();
        nextDay = new Date(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate() + 1);
        return !!this.props.sale.date && new Date(this.props.sale.date) < nextDay;
    }

    isEmptyProfit() {
        return this.props.sale.profit === 0;
    }

    render() {
        const { provided, innerRef } = this.props;
        return (
            <div
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={innerRef}
                onClick={this.handleCardClick}
                className={"card-wrapper priority-shadow-" + this.props.sale.priorityId + ' ' + (this.state.isOver ? 'over' : '') + (this.props.sale.isSelected ? ' selected' : '') + (this.isDatePast() ? ' overdue-invoice-card ' : '') + (this.isEmptyProfit() ? ' empty-profit-invoice-card ' : '') + (!this.props.sale.isFlagged ? '' : ' flagged')}
            >
                <div style={{ "background": this.props.sale.projectTypeColor}}>
                    <div className="not-pointers">
                        <CardRow className={"clearfix priority-gradient-" + this.props.sale.priorityId}>
                            <div className="small-sale-card-number"><span onClick={() => window.open(this.props.sale.crmLink)}>{this.props.sale.number}</span></div>
                            <div className="row-right">{this.props.sale.projectTypeName}</div>
                        </CardRow>
                        <div onClick={(e) => { !e.ctrlKey && SaleStore.openInvoiceDialog(this.props.sale); }}>
                        <CardRow>
                            <div className="small-card-caption">{this.props.sale.caption}</div>
                        </CardRow>

                        <CardRow>
                            <div className="project-block">{this.props.sale.projectName}</div>
                        </CardRow>
                        <CardRow>
                                <div className="row-left">{this.props.sale.profit && this.props.sale.profit.toLocaleString().replace(/\,/g, ' ')}</div>
                            <div className="sale-card-avatar-block"><UserAvatar userId={this.props.sale.ownerId} /></div>
                        </CardRow>
                            {this.props.sale.controller &&
                                <CardRow>
                            Контроллер <div className="sale-card-avatar-block">{this.props.sale.controller}</div>
                            </CardRow>}
                            <CardRow>
                                {this.props.sale.account}
                            </CardRow>
                    </div>
                </div>
                <CardRow>
                        <div className="sale-date-block">{this.props.sale.date && new Date(this.props.sale.date).toLocaleDateString()}</div>
                        
                    {this.props.sale.isFlagged &&
                        <IconButton
                            key="flag"
                            aria-label="флаг"
                            color="inherit"
                            className="sale-flag-button"
                            onClick={this.unFlag}
                            size="large">
                            <FlagIcon style={{ fill: 'red' }}/>
                        </IconButton>}
                    {!this.props.sale.isFlagged &&
                        <IconButton
                            key="flag"
                            aria-label="флаг"
                            color="inherit"
                            className="sale-flag-button flag-grey"
                            onClick={this.flag}
                            size="large">
                            <FlagOutlinedIcon />
                            </IconButton>}
                        {this.props.sale.isFlagged && <div className="sale-delayto-block">{this.props.sale.delayTo && new Date(this.props.sale.delayTo).toLocaleDateString()}</div>}
                        <Tooltip title="Создать задачу">
                            <IconButton
                                onClick={this.handleWorkAdd}
                                className="sale-card-add-work-button"
                                size="large">
                                <AddIcon style={{ fill: "red" }} />
                            </IconButton>
                        </Tooltip>
                </CardRow>

                <Dialog
                    onClose={this.handleCommentClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.isCommentDialogOpen}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleCommentClose}>
                        {this.state.flagDialogTitle}
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography>
                            <TextField required
                                id="standard-required"
                                label="Комментарий"
                                fullWidth
                                margin="normal"
                                value={this.state.flagComment}
                                multiline
                                onChange={this.handleChange('flagComment')}
                            />
                        </Typography>
                        {this.state.newFlag && <Typography>
                            <TextField required
                                id="date"
                                label="Стоппер до"
                                type="date"
                                fullWidth
                                margin="normal"
                                value={this.state.delayTo}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={this.handleChange('delayTo')}
                            />
                        </Typography>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCommentSave} color="primary">
                            Сохранить
                        </Button>
                        <Button onClick={this.handleCommentClose} color="primary">
                            Отменить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
        );
    }
}
